import { render, staticRenderFns } from "./TranslatorInput.vue?vue&type=template&id=44a0b31e"
import script from "./TranslatorInput.vue?vue&type=script&lang=js"
export * from "./TranslatorInput.vue?vue&type=script&lang=js"
import style0 from "./TranslatorInput.vue?vue&type=style&index=0&id=44a0b31e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports